import { createAction } from '@gef-ui/utils/fsaActions';
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { fileInputActions } from '../../constants';
import { composeAction } from '../../utils';
/**
 * Add file input to form
 *
 * @documented
 * @category Action
 * @example
 *
 * 	addFileInput('form')('file.upload')
 *
 */ export const addFileInput = memoizeWithIdentity((formName)=>createAction(composeAction(formName, fileInputActions.ADD_FILE_INPUT)));
/**
 * remove file input from form
 *
 * @documented
 * @category Action
 * @example
 *
 * 	removeFileInput('form')('file.upload')
 *
 */ export const removeFileInput = memoizeWithIdentity((formName)=>createAction(composeAction(formName, fileInputActions.REMOVE_FILE_INPUT)));
